import { useEffect } from 'react';
import { virtualBackgroundStore } from 'features/VirtualBackground/state/store/virtualBackground';
import { selectActiveProcessor } from 'features/VirtualBackground/state/selectors/virtualBackground';
import { virtualBackgroundService as service } from 'features/VirtualBackground/classes/VirtualBackgroundService';

export const useManageBackgroundProcessor = () => {
    const selectedProcessor = selectActiveProcessor();

    useEffect(() => {
        if (!selectedProcessor) return;

        (async () => {
            try {
                await service.updateAllManagers();
            } catch (error) {
                console.error('Failed to update processor:', error);
            }
        })();
    }, [selectedProcessor]);
};

// Экспортируем для совместимости
export const setSelectedProcessor = (newSelectedProcessorKey: string) => {
    const selectedProcessorInfo = selectActiveProcessor();
    if (selectedProcessorInfo && selectedProcessorInfo === newSelectedProcessorKey) {
        console.warn('The same processor is already applied');
        return;
    }
    virtualBackgroundStore.setActiveProcessor(newSelectedProcessorKey);
};
